(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {

  const checkElements = setInterval(function() {
    const padre = document.querySelector('.product-details .divider');
    const hijo = document.querySelector('.container-pair');
    
    if (padre && hijo) {
      clearInterval(checkElements);
      padre.appendChild(hijo);
    }
  }, 100); 
});
  } catch(e) { console.error(e); }
})();

})();
